// src/store/subscriptionPurchaseModalManagment/actions.ts

import { Dispatch } from 'redux';

import {
  OPEN_SUBSCRIPTION_PURCHASE_MODAL,
  CLOSE_SUBSCRIPTION_PURCHASE_MODAL,
  SubscriptionPurchaseModalActionTypes,
} from './types';

export const openSubscriptionPurchaseModal = (
  productVariantCode: string,
  priceCode:          string,
  amount:             number,
  label:              string,
) => (dispatch: Dispatch<SubscriptionPurchaseModalActionTypes>) => {
  dispatch({
    type: OPEN_SUBSCRIPTION_PURCHASE_MODAL,
    payload: { productVariantCode, priceCode, amount, label },
  });
};

export const closeSubscriptionPurchaseModal = () => (dispatch: Dispatch<SubscriptionPurchaseModalActionTypes>) => {
  dispatch({ type: CLOSE_SUBSCRIPTION_PURCHASE_MODAL });
};
